/* eslint-disable react/jsx-no-comment-textnodes */

import React from "react";
import styled from "styled-components";
import { Col } from "react-bootstrap";

import {
  Block,
  Carousel,
  Footer,
  NamedHeader,
  PageIntroKnaifel,
  SidesKnaifel,
  Spacer,
  Text,
  TypographyWrapper,
} from "../../../lib";

const Image = styled.img`
  width: 100%;
`;

const { PUBLIC_URL } = process.env;

const Diary: React.FC = () => (
  <TypographyWrapper>
    <NamedHeader name="время" />

    <PageIntroKnaifel author="knaifel" name="diary" />

    <Spacer size={20} />

    <SidesKnaifel hideRight="source">
      <Col
        lg={{ offset: 1, span: 10 }}
        style={{ transform: "translateX(20px)" }}
      >
        <Spacer size={10} />
        <Text>
          фрагменты дневника, сохранена авторская пунктуация и орфография
        </Text>
        <Spacer size={4} />
      </Col>

      <Spacer size={8} />

      <Block>
        <>1975</>
        <Spacer size={1} />
        <Text>3.08.75 [первая запись]</Text>
        <Text>
          Процент записанного будет чрезвычайно низок.
          <br />
          Очень надеюсь на обретение инерции.
        </Text>
        <Spacer size={1} />
        <Text>18.08.75</Text>
        <Text>
          Обязательно:
          <br />
          Сочинение без единого нарушения (опознавательных знаков другого
          смысла) ... нотной записи. Возвращение по спирали от «constant’ы»
          (противоположного полюса). Кстати, учесть при реализации – при
          необходимости возможность записи замкнутых (кольцевых) партий (без
          указаний и существования начала и конца) на лентах Мебиуса.
        </Text>
        <Spacer size={1} />
        <Text>29.08.75</Text>
        <Text>
          Театр – как неистребимая и постоянная форма существования и действия и
          музыки.
        </Text>
        <Spacer size={1} />
        <Text>02.09.75</Text>
        <Text>
          Несколько сочинений разного времени на один и тот же текст.
          <br />
          Пение (особенно) и игра по произвольным звукам в точно записанной
          ритмической сетке.
        </Text>
        <Spacer size={1} />
        <Text>04.10.75</Text>
        <Text>
          Чтение слушателями текста в определенном темпе с точно определенного в
          партитуре момента во время звучания музыки как одного из
          полифонических слагаемых.
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1976</>
        <Spacer size={1} />
        <Text>14.03.76</Text>
        <Text>
          Постоянное мое стремление к гармонии во всем!
          <br />
          Внутреннее ощущение. Во всех формах музыки и жизни!
        </Text>
        <Spacer size={1} />
        <Text>06.08.76</Text>
        <Text>
          Параллельное исполнение 2х и 3х сочинений (одновременно на разных
          площадках) – вертикальное соединение.
          <br />
          + объединение на каждой из площадок нескольких разных сочинений в одно
          – горизонтальное соединение.
          <br />
          Магические квадраты (их использование) + м.б. магические кубы
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1977</>
        <Spacer size={1} />
        <Text>23.04.77</Text>
        <Text>
          Могут появится другие идеи и принципы, состояния и возможности.
          <br />
          Поэтому обязательно «свободные» допуски при сочинении сценария!
        </Text>
        <Spacer size={1} />
        <Text>08.09.77</Text>
        <Text>Прожить на острие сути существования!</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1978</>
        <Spacer size={1} />
        <Text>04.09.78</Text>
        <Text>
          Объяснение моего интуитивного и сильнейшего стремления к «факту
          прецедента» – необходимость выразить наисложнейшую структуру
          максимально просто.
        </Text>
        <Spacer size={1} />
        <Text>19.11.78</Text>
        <Text>Тайна двойки – в ней основа ритма (он основа всех основ)!</Text>
        <Spacer size={1} />
        <Text>26.11.78 (берег моря – Репино)</Text>
        <Text>Мой путь – это чье-то ВЕЛЕНИЕ!</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1979</>
        <Spacer size={1} />
        <Text>06.07.79</Text>
        <Text>Как ясно все, Господи!</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1980</>
        <Spacer size={1} />
        <Text>21.07.80</Text>
        <Text>«Первое сочинение» – это выражение учения и обретение веры.</Text>
        <Spacer size={1} />
        <Text>05.12.80</Text>
        <Text>У меня удивительная натура: все идет впрок!</Text>
        <Spacer size={1} />
        <Text>22.12.80</Text>
        <Text>Мне необходим максимум, чтобы достигнуть минимума!</Text>
        <Spacer size={1} />
        <Text>29.12.80</Text>
        <Text>
          Возможно, все мои отчаяния, страдания, периодически мучившие (особенно
          в юности) ощущения своей неполноценности, ущербности, возможно и годы,
          потраченные на поиски материальной основы для возможности реализации
          моей сути – все это возможно, действительно от отсутствия моего
          общества, моего времени, моих людей.
          <br />
          Я действительно сейчас здесь – чужой!..
          <br />
          _________
          <br />
          Я не живу с обществом – пора это признать!
          <br />
          Хотя м.б. в этом есть какой-то смысл?! (Мой вопрос, и хочется верить…)
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1981</>
        <Spacer size={1} />
        <Text>30.03.81</Text>
        <Text>Еще получится и насладиться собой!</Text>
        <Spacer size={1} />
        <Text>14.11.81</Text>
        <Text>…Показалось, что шедевр создается при потере бдительности…</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1982</>
        <Spacer size={1} />
        <Text>02.08.82</Text>
        <Text>Взгляд на настоящее из будущего…</Text>
        <Spacer size={1} />
        <Text>14.08.82</Text>
        <Text>
          Помни об осе или мухе, не способной вырваться за ячейки оконного
          стекла...
        </Text>
        <Spacer size={1} />
        <Text>24.08.82</Text>
        <Text>
          (+) опыт горения дров (необходимость постоянного дробления, изменения
          положения и т.д.) Условие поддержания сильного огня!
        </Text>
        <Spacer size={1} />
        <Text>09.10.82</Text>
        <Text>
          Орган и колокола (натуральные) – синтез церквей, символ единения вер –
          отражение в дыре “Соляриса”, начало еще в “Кентервильском привидении”
          и т.д. и пр.
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1983</>
        <Spacer size={1} />
        <Text>26.02.83</Text>
        <Text>
          Как можно меньше поддающегося анализу, как можно больше не
          поддающегося (к структурам будущих композиций)
        </Text>
        <Spacer size={1} />
        <Text>28.05.83</Text>
        <Text>Добытие и достижение художественной сумасшедшинки…</Text>
        <Spacer size={1} />
        <Text>03.07.83</Text>
        <Text>
          Выявление конкретного через движение, точнее: проявление сути – каждый
          раз неповторимое через конкретное движение и тоже каждый раз
          неповторимое (!)
        </Text>
        <Spacer size={1} />
        <Text>15.09.83</Text>
        <Text>
          Когда не работаешь, всегда жалко: либо, что уже сделал, либо, что еще
          не сделал
        </Text>
        <Spacer size={1} />
        <Text>26.09.83</Text>
        <Text>Самая ужасная ошибка – пытаться сделать шедевр</Text>
        <Spacer size={1} />
        <Text>15.12.83</Text>
        <Text>
          Для меня сочинительство музыки – единственная возможность прожить
          (выжить), единственное оправдание моего существования и единственный
          смысл…
        </Text>
        <Spacer size={1} />
        <Text>26.12.83</Text>
        <Text>Делаю то, что не делать не могу, что только и могу делать!</Text>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/diary/1.jpg`}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>1984</>
        <Spacer size={1} />
        <Text>21.02.84</Text>
        <Text>
          Мне надо обязательно обратить в благо складывающуюся жизненную
          ситуацию: пройти-пережить высшие духовные высоты, завершив
          (обязательно) “Нику” и до (возможного пока) конца ощутить полнокровие
          музыкального языка, обратившись к аудитории во много миллионов (в
          “Противостоянии”).
        </Text>
        <Spacer size={1} />
        <Text>18.06.84</Text>
        <Text>И как, оказывается, важен контекст собственного творчества…</Text>
        <Spacer size={1} />
        <Text>16.11.84</Text>
        <Text>
          Достижение все большей чистоты – как смысл творческого процесса.
        </Text>
        <Spacer size={1} />
        <Text>27.12.84</Text>
        <Text>
          Втиснутся всеми своими несоразмерностями в “рамки” (Большой) музыки
          [процесс моей (творч.) жизни]
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1985</>
        <Spacer size={1} />
        <Text>21.04.85</Text>
        <Text>Соответствие сути возникающей музыки сути инструментария</Text>
        <Spacer size={1} />
        <Text>30.05.85</Text>
        <Text>
          Джаз..!!!!!!
          <br />
          (непреходящее)
          <br />
          _______
          <br />
          М.б. соединить (уточняю) мое любимейшее:
          <br />
          балет - па де
          <br />
          джаз
          <br />
          цирк
          <br />
          футбол - (хэт трик)
          <br />
          +польки, галопы – оперетта и тд
        </Text>
        <Spacer size={1} />
        <Text>20.12.85</Text>
        <Text>
          ...и не исключаю, что я стремлюсь к тому, что, в сущности, уже имею…
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1987</>
        <Spacer size={1} />
        <Text>24.03.87</Text>
        <Text>
          Витальный характер предварительного периода работы над сочинением (!)
        </Text>
        <Spacer size={1} />
        <Text>20.05.87</Text>
        <Text>
          Перед лицом мировой культуры – в обнажающиеся моменты прямого контакта
          – все и любое содеянное всегда кажется недостойным и несостоятельным…
          <br />
          Но всегда рождает жгучее желание работать, наверстать, употребить все
          возможное (и оставшееся) на хоть какое-нибудь преодоление этой
          пропасти!
        </Text>
        <Spacer size={1} />
        <Text>26.05.87</Text>
        <Text>
          Сочинение состоит в том, чтобы не сочинять, а лишь услышать,
          вслушаться, расслышать!
        </Text>
        <Spacer size={1} />
        <Text>12.08.87</Text>
        <Text>
          Одиночество – принципиальное – неотъемлемая черта-свойство творящего
          субъекта
          <br />
          [он со всеми, а реально – один]
        </Text>
        <Spacer size={1} />
        <Text>09.09.87</Text>
        <Text>
          Человеку, не испытавшему стихию творческого акта, никогда не понять
          очевидной истины:
          <br />
          творческий акт [vs] все остальное, в разной степени испытанное
          человеком
        </Text>
        <Spacer size={1} />
        <Text>25.12.87</Text>
        <Text>
          Максимально все уплотнить
          <br />
          Смотреть максимально широко
          <br />
          Не жаловаться – ни себе, ни кому-либо
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1988</>
        <Spacer size={1} />
        <Text>22.02.88</Text>
        <Text>
          Возможно, главнейшее в проблемах – принципиально (и конкретно) не
          знать каждого следующего шага и шажка [при воплощении подготовленного
          замысла]
          <br />
          (рукотворное воссоздание)
          <br />
          …это и есть “творю”
        </Text>
        <Spacer size={1} />
        <Text>02.03.88</Text>
        <Text>
          …Я люблю сочинять музыку.
          <br />
          Ну что тут сделаешь!..
        </Text>
        <Spacer size={1} />
        <Text>10.03.88</Text>
        <Text>
          Настоящее творческое состояние – всегда болезнь и невозможность…
        </Text>
        <Spacer size={1} />
        <Text>04.06.88</Text>
        <Text>
          И, если верно, что в каждой творческой жизни должно быть “главное”
          сочинение, то похоже, я только еще к нему устремлен…
        </Text>
        <Spacer size={1} />
        <Text>16.06.88</Text>
        <Text>
          А интуиция – это, видимо, и постоянные внутренние весы и непостижимый
          резонансный “аппарат”.
          <br />
          Быть может мои проблемы в объективно сложившейся отозванности от
          “моей” культуры
          <br />
          [Я одинаково одинок и здесь, и на Западе]
        </Text>
        <Spacer size={1} />
        <Text>11.09.88</Text>
        <Text>
          Главное в нашей жизни – не терять ощущение постоянного Сопряжения!
          <br />
          Любое данное относительно, и невольно отдаваясь ему в нашем
          Существовании-Сознании, нужно вовремя почувствовать необходимость его
          сопряжения с …
          <br />
          В этом состоит единственная, как кажется, Правда!
          <br />
          ________
          <br />
          отныне установка к кино: одно прикосновение [ого! Микеланджеловский
          удар], главное и единственное – найти это прикосновение (вся работа в
          этом!)
        </Text>
        <Spacer size={1} />
        <Text>14.09.88</Text>
        <Text>Принадлежать Времени – суметь ему отдаться</Text>
        <Spacer size={1} />
        <Text>26.09.88</Text>
        <Text>
          Нотный текст – следы сокровенного и глубиннейшего, сосредоточеннейшего
          интонирования!
        </Text>
        <Spacer size={1} />
        <Text>13.12.88</Text>
        <Text>
          Все дело в том, что у меня начинается там, где обычно все кончается!
        </Text>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/diary/2.jpg`}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>1989</>
        <Spacer size={1} />
        <Text>25.06.89</Text>
        <Text>Оставить ровно столько следов, сколько необходимо… (!)</Text>
        <Spacer size={1} />
        <Text>01.07.89</Text>
        <Text>
          И все-таки не решать каждый раз Проблему, а каждый раз только Служить,
          еще и еще осуществляя “Заведомое..”
        </Text>
        <Spacer size={1} />
        <Text>13.07.89</Text>
        <Text>
          Самые необыкновенные ошеломляющие мгновения счастья-наслаждения я
          испытывал от себя (в смысле не пережитого ни в чем внешнем и ни от
          чего внешнего, в смысле несравненной уникальности этого природой
          данного)
        </Text>
        <Spacer size={1} />
        <Text>01.08.89 (вечером, около 20ч)</Text>
        <Text>
          Осознание возможно наступающей (для меня) эры принципиальной
          “антиконцептуальности”.
          <br />
          Все будущие композиции с единственной задачей – нахождение
          единственной гармонии в сопряжении “любого” с “любым”
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1990</>
        <Spacer size={1} />
        <Text>02.08.90</Text>
        <Text>
          Мне бы не хотелось даже самое привлекательное испытывать более чем
          один раз. Мне бы хотелось постоянно испытывать все новые единицы!
        </Text>
        <Spacer size={1} />
        <Text>12.10.90</Text>
        <Text>
          Мой принцип-способ сочинения в сущности предельно прост: каждое
          мгновение – шаг должен быть единственно точным (правдивым), совершенно
          не зависящим ни от чего привходящего – лишь правдой (всепоглощающим
          резонансом единствнно возможного, диктуемого необъяснимым, в постоянно
          предельном Личном “магнитном” поле) предыдущего шага…
          <br />
          Единый (и бесконечный) процесс: правда, рождаемая правдой…
          <br />
          Истина, “какая бы они ни была(!), царство правды..
          <br />
          (ср. набоковское: “отдаваясь влечению, правда которого была в его же
          силе”).
        </Text>
        <Spacer size={1} />
        <Text>20.10.90</Text>
        <Text>
          В “припеве” Хармсовского “Миллиона” (“Раз, два, три, четыре..)
          неплохой образ моей работы…
        </Text>
        <Spacer size={1} />
        <Text>20.10.90</Text>
        <Text>
          Все (абсолютно все!) иллюзорно. Но только с помощью Чисел это можно
          передать!..
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1991</>
        <Spacer size={1} />
        <Text>07.04.91</Text>
        <Text>Касания в кино – все новые прививки жизнеощущения…!</Text>
        <Spacer size={1} />
        <Text>18.06.91</Text>
        <Text>
          И оказывается, что я большей частью уже давно принадлежу Тишине!
        </Text>
        <Spacer size={1} />
        <Text>из сна 16.12.91</Text>
        <Text>Ростропович сделал над С.-Петербургом небо (еще одно)</Text>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/diary/3.jpg`}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>1992</>
        <Spacer size={1} />
        <Text>07.01.92 (С Рождеством и Н.годом!)</Text>
        <Text>Всю жизнь культивирую НЕЗНАНИЕ!</Text>
        <Spacer size={1} />
        <Text>24.01.92</Text>
        <Text>“...к высшей мере наказания через жизнь…”</Text>
        <Spacer size={1} />
        <Text>12.04.92</Text>
        <Text>…либо не имеет цены, либо ничего не стоит…!</Text>
        <Spacer size={1} />
        <Text>06.10.92</Text>
        <Text>
          В сущности число ничего не значит…
          <br />
          Я обозначаю эту ничегонезначимость…
          <br />
          Обозначение ничегонезначимости – способ существования искусства!
        </Text>
      </Block>

      <Spacer size={8} />
      <Block>
        <>1993</>
        <Spacer size={1} />
        <Text>ночью 14.11.1993</Text>
        <Text>
          Проживание за мои годы разных типов (!) святой болезни – творчества
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1994</>
        <Spacer size={1} />
        <Text>19.01.94</Text>
        <Text>
          Проходит время и я начинаю больше понимать в своей музыке (написанной)
        </Text>
        <Spacer size={1} />
        <Text>26.02.94</Text>
        <Text>Еще предстоит открыть – явить меня миру</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1995</>
        <Spacer size={1} />
        <Text>16.10.95</Text>
        <Text>
          Моя сразу же и стихийно проявившаяся неспособность сочинять не от
          начала и до конца тоже “не случайна”!
          <br />
          {/* -------------------------------------------------------------------------  */}
          В момент истины время становится в вертикаль (теряет свою земную
          власть)
        </Text>
        <Spacer size={1} />
        <Text>вечер 09.11.95!</Text>
        <Text>
          Сколько же бывает судьбоносного и благословенного в “ошибке”!
        </Text>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/diary/4.jpg`}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>1996</>
        <Spacer size={1} />
        <Text>—</Text>
        <Text>Для всех отчасти свой (!)</Text>
        <Spacer size={1} />
        <Text>04.07.96</Text>
        <Text>
          Важно именно открытие “очевидного”, весь путь, который привел меня к
          Богу!
        </Text>
        <Spacer size={1} />
        <Text>07.07.96</Text>
        <Text>
          В конце концов “внимательность” – ключевое слово: в нем и все о
          вертикальном (о полноте момента) и о житии во всем (этими моментами!)
        </Text>
        <Spacer size={1} />
        <Text>23.07.96</Text>
        <Text>
          Великая способность делать очевидный шаг (он очевиден и (но) как
          обескураживающе редко приходит мысль его сделать!)
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1997</>
        <Spacer size={1} />
        <Text>25.07.97</Text>
        <Text>
          Вообще, строго говоря, музыке наплевать, что кроме музыки содержит
          музыка!
          <br />
          Но мне почему-то отпущено иметь эту заботу…
        </Text>
        <Spacer size={1} />
        <Text>02.08.97</Text>
        <Text>
          Момент музыки – чистейшее предстояние Богу.
          <br />
          {/* -------------------------------------------------------------------------  */}
          И все определяется степенью приближения к этому
        </Text>
        <Spacer size={1} />
        <Text>08.11.97</Text>
        <Text>Крест – основа (суть и принцип) нашей жизни</Text>
        <Spacer size={1} />
        <Text>ноябрь 1997</Text>
        <Text>
          …воспринимая все “мешающее”, “нарушающее” – как прямое указание!
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1998</>
        <Spacer size={1} />
        <Text>04.02.98</Text>
        <Text>
          Ключевой вопрос о Боге имеет сущностный ответ “от противного”, что
          дает основание также ориентироваться и во всех других бесконечных
          вопросах
        </Text>
        <Spacer size={1} />
        <Text>10.06.98</Text>
        <Text>
          Я как Алиса постоянно меняюсь в размерах (то ли увеличиваюсь, то ли
          уменьшаюсь), и все быстрее, так, что не поспеваю за собой в сочинении
          Картинок
          <br />
          (приходится переделывать только что сделанное под “текущий размер”)...
          Вот беда!..
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>1999</>
        <Spacer size={1} />
        <Text>26.02.99</Text>
        <Text>Бах – сверхпроводимость</Text>
        <Spacer size={1} />
        <Text>06.05.99</Text>
        <Text>
          Исполнителям (вслед за мной): питаться (произрастать) вертикалью!
        </Text>
        <Spacer size={1} />
        <Text>15.07.99</Text>
        <Text>Я болен жизнью(!)</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2000</>
        <Spacer size={1} />
        <Text>17.01.2000</Text>
        <Text>Тайна будущей жизни, не “бо́льшая” нынешней и “прошлой”</Text>
        <Spacer size={1} />
        <Text>17.02.00</Text>
        <Text>
          Путь – только в открывающейся правде каждого шага (!) /
          <br />
          Слуховое кино
        </Text>
        <Spacer size={1} />
        <Text>01.05.2000</Text>
        <Text>
          Главный “враг” – любая примесь вообще (!)
          <br />
          Качество горения костра – в качестве его “конструкции”
        </Text>
        <Spacer size={1} />
        <Text>03.06.2000</Text>
        <Text>“Упасть в небо” – лучшее название моим проделкам</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2002</>
        <Spacer size={1} />
        <Text>(Во сне) 04.04.02</Text>
        <Text>Вот А.Кнайфель: у ворот всеобъемлющего кино</Text>
        <Spacer size={1} />
        <Text>30.04.02</Text>
        <Text>Делание – наиболее полное пребывание в Настоящем!</Text>
        <Spacer size={1} />
        <Text>07.05.02</Text>
        <Text>
          Моя врожденная потребность находиться в тени с годами проявляется
          ужасом быть не в тени
        </Text>
        <Spacer size={1} />
        <Text>11.10.02</Text>
        <Text>Диалоги со словом и числом (!)</Text>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/diary/5.jpg`}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>2003</>
        <Spacer size={1} />
        <Text>08.10.03</Text>
        <Text>
          Слишком многое названо, произнесено… время умолчания необходимо как
          дыхание
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2004</>
        <Spacer size={1} />
        <Text>10.10.04</Text>
        <Text>В житейском смысле я неуязвим только во время сочинения (!)</Text>
        <Spacer size={1} />
        <Text>20.12.04</Text>
        <Text>
          Если постоянно писать музыку – не остается времени ее услышать
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2005</>
        <Spacer size={1} />
        <Text>26.02.05</Text>
        <Text>
          Пребывание, постоянная устремленность в зоне “возможное” –
          “невозможное”...
        </Text>
        <Spacer size={1} />
        <Text>21.12.05</Text>
        <Text>Делание – как единственная возможность обретения</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2006</>
        <Spacer size={1} />
        <Text>13.01.06</Text>
        <Text>
          … я полагаюсь на свой слух только с момента Божьего благословения:
          <br />
          во всем, что можно выбрать своей волей я вверяюсь числу,
          проистекающему из Священного Слова
        </Text>
        <Spacer size={1} />
        <Text>23.11.06</Text>
        <Text>
          Мне этот мир в самую пору… но музыка моя заветная всякий раз
          оказывается для него чрезмерной…
        </Text>
        <Spacer half size={4} />
        <Image
          alt="Александр Кнайфель"
          src={`${PUBLIC_URL}/assets/images/knaifel/diary/6.jpg`}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>2007</>
        <Spacer size={1} />
        <Text>12.06.07</Text>
        <Text>Есть вещи записанные, а есть написанные… Тут вся суть!</Text>
        <Spacer size={1} />
        <Text>10.12.07</Text>
        <Text>Бог знает, мы догадываемся!</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2008</>
        <Spacer size={1} />
        <Text>02.01.08 (С Н.г!)</Text>
        <Text>
          Каждый шаг земной жизни требует нахождения всегда новой, единственной
          точки перекрестия!
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2009</>
        <Spacer size={1} />
        <Text>07.10.09</Text>
        <Text>
          Кажется, настает время, когда я начинаю не выдерживать самого себя…
          (!)
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2010</>
        <Spacer size={1} />
        <Text>12.08.10</Text>
        <Text>На пределе, но при деле (+15.12.13)</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2011</>
        <Spacer size={1} />
        <Text>10.09.11</Text>
        <Text>
          В пылающем огне творчества все смыслы теряют свою привязанность!!!
        </Text>
        <Spacer size={1} />
        <Text>16.10.11</Text>
        <Text>Гения хватает, а за талант молю у времени</Text>
        <Spacer size={1} />
        <Text>19.10.11</Text>
        <Text>Уметь делать и уметь не делать!</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2012</>
        <Spacer size={1} />
        <Text>12.03.12</Text>
        <Text>Когда я один – я со всеми, когда я со всеми – я один.</Text>
        <Spacer size={1} />
        <Text>08.06.12</Text>
        <Text>Тесно во времени..</Text>
        <Spacer size={1} />
        <Text>19.06.12</Text>
        <Text>Внедрению в Музыку противостоит все сущее…</Text>
        <Spacer size={1} />
        <Text>20.06.12</Text>
        <Text>
          Устоял! (отходов гора, но есть изделие)
          <br />
          (с Атлантами не дружу, но кариатидой побыл)
        </Text>
        <Spacer size={1} />
        <Text>17.12.12</Text>
        <Text>
          …мое сочинение музыки от стремления (неизбывного!) исполнять уже
          Сочиненное…
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2013</>
        <Spacer size={1} />
        <Text>03.02.13</Text>
        <Text>Генеральное сражение без срока</Text>
        <Spacer size={1} />
        <Text>03.03.13</Text>
        <Text>Гения хватает, а вот таланта не всегда</Text>
        <Spacer size={1} />
        <Text>05.05.13 (Пасха)</Text>
        <Text>
          Задача ремесла – материалу обрести черты единственности в данном
          контексте.
        </Text>
        <Spacer size={1} />
        <Text>05.05.13 (Пасха)</Text>
        <Text>
          Любой истинно рожденный музыкальный текст изначально невозможно
          исполнить (произнести) во всей его полноте!
        </Text>
        <Spacer size={1} />
        <Text>17.06.13</Text>
        <Text>Решающее в работе – моменты “не работы”</Text>
        <Spacer size={1} />
        <Text>23.08.13 (Рачье)</Text>
        <Text>
          Вера неизбежна еще и потому, что после неопалимого жара встречи –
          “единосущно” трезвление!
        </Text>
        <Spacer size={1} />
        <Text>15.12.13</Text>
        <Text>Я при деле в пределе</Text>
        <Spacer half size={4} />
        <Carousel
          autoHeight
          slides={[
            { url: `${PUBLIC_URL}/assets/images/knaifel/diary/7.jpg` },
            { url: `${PUBLIC_URL}/assets/images/knaifel/diary/7a.jpg` },
          ]}
        />
      </Block>

      <Spacer size={8} />

      <Block>
        <>2014</>
        <Spacer size={1} />
        <Text>22.06.14</Text>
        <Text>
          С начала 70-х (после первой части “Жанны”), начался мой путь, подобный
          пути в землю обетованную через пустыню..
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2015</>
        <Spacer size={1} />
        <Text>27.02.15</Text>
        <Text>
          Весь “грех” – от возможностей, а плодоносит-то – только невозможность!
        </Text>
        <Spacer size={1} />
        <Text>09.05.15</Text>
        <Text>Искусство живет единым братством резонансов</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2016</>
        <Spacer size={1} />
        <Text>14.01.16 (“Кентервиль”, действие II)</Text>
        <Text>
          Все нашли себя и друг друга – ключ и цель всех моих “редактур”
        </Text>
        <Spacer size={1} />
        <Text>01.10.16</Text>
        <Text>То, что я сделал и делаю со своим другом Шуриком Кнайфелем</Text>
        <Spacer size={1} />
        <Text>23.10.16</Text>
        <Text>В рождении текста необходимо быть футбольной звездой!</Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2019</>
        <Spacer size={1} />
        <Text>09.03.19</Text>
        <Text>Живу и гастролирую в Санкт-Петербурге</Text>
        <Spacer size={1} />
        <Text>ранним утром 07.06.19</Text>
        <Text>…полон дара…</Text>
        <Spacer size={1} />
        <Text>19.09.19</Text>
        <Text>
          Всякое действие без сознания необходимости быть прозрачным – тупик
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2020</>
        <Spacer size={1} />
        <Text>07.01.20</Text>
        <Text>
          К Рождеству, Гена Гольштейн – мне: “Не остывать в выполнении
          Поручения”
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2021</>
        <Spacer size={1} />
        <Text>20.01.21</Text>
        <Text>
          Чувствую себя черенком, привитым к Господнему Древу Жизни и Музыки
        </Text>
        <Spacer size={1} />
        <Text>25.02.21</Text>
        <Text>
          Я имею ввиду не себя, а Александра Кнайфеля – за него я отвечаю
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2022</>
        <Spacer size={1} />
        <Text>04.03.22</Text>
        <Text>
          Все прошедшее – глаголами настоящего времени.
          <br />
          Все прошедшее – неотъемлемое настоящего.
        </Text>
      </Block>

      <Spacer size={8} />

      <Block>
        <>2023</>
        <Spacer size={1} />
        <Text>21.03.23 (С Н.г.!)</Text>
        <Text>
          Каждое произведение ровно такое какое оно есть – подобно любому живому
          созданью.
        </Text>
      </Block>
    </SidesKnaifel>

    <Spacer size={80} />

    <Footer />
  </TypographyWrapper>
);

export default Diary;
